import { Gallery_Navigation_default } from "./chunk-DIQD4UXU.js";
import { Gallery_Root_default } from "./chunk-ZCIZNKXM.js";
import { Gallery_default } from "./chunk-T52UOVEX.js";
import { Gallery_Button_default } from "./chunk-WU74YBK4.js";
import { Gallery_Item_default } from "./chunk-F34EAMCI.js";
import { Gallery_Navigation_MoreButton_default } from "./chunk-C4YTHYFM.js";
import { Gallery_Navigation_Item_default } from "./chunk-I365FE5F.js";

// src/components/Gallery/index.ts
var GalleryNavigationComponent = Gallery_Navigation_default;
GalleryNavigationComponent.Item = Gallery_Navigation_Item_default;
GalleryNavigationComponent.Item.displayName = "Gallery.Navigation.Item";
GalleryNavigationComponent.MoreButton = Gallery_Navigation_MoreButton_default;
GalleryNavigationComponent.MoreButton.displayName = "Gallery.Navigation.MoreButton";
var GalleryComponent = Gallery_default;
GalleryComponent.Button = Gallery_Button_default;
GalleryComponent.Button.displayName = "Gallery.Button";
GalleryComponent.Root = Gallery_Root_default;
GalleryComponent.Root.displayName = "Gallery.Root";
GalleryComponent.Items = Gallery_Root_default;
GalleryComponent.Items.displayName = "Gallery.Items";
GalleryComponent.Item = Gallery_Item_default;
GalleryComponent.Item.displayName = "Gallery.Item";
GalleryComponent.Navigation = GalleryNavigationComponent;
GalleryComponent.Navigation.displayName = "Gallery.Navigation";
export { GalleryComponent };